import React from 'react';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import UserAvatarWithName from '../../../../components/UserAvatar/UserAvatarWithName';
import './SelectMemberList.scss';

class SelectMemberList extends BaseComponent {

  handleSelectUser(user) {
    if (this.props.selectMember) {
      this.props.selectMember(user);
    }
  }

  createUserList() {
    let userList = this.props.users || [];
    
    userList.sort((u1, u2) => {
      if (u1.last_name < u2.last_name) return -1;
      else if (u1.last_name > u2.first_name) return 1;
      else return 0;
    });
    userList = userList.map((user) => {
      return <div key={user.id} className="member-entry">
          <UserAvatarWithName key={user.id} user={user} selectUser={this.handleSelectUser} />
        </div>;
    });
    return userList;
  }

  render() {
    const userList = this.createUserList();

    let style = {};
    if (this.props.height) {
      style.height = this.props.height;
    }

    let caption = null;
    if (this.props.caption) {
      caption = <div className="member-list-caption">{this.props.caption}</div>;
    }
    
    return(
      <div className="select-member-list" >
        {caption}
        <div className="select-member-scroller" style={style}>
          <div className="select-member-container">
            {userList}
          </div>  
        </div>  
      </div >
    );
  }
}

export default SelectMemberList;



// WEBPACK FOOTER //
// ./src/components/TeamPopup/SelectTeamMembers/SelectMemberList/index.js